class KlaviyoNewsletter extends HTMLElement {
  constructor() {
    super();

    this.intervalFooter = setInterval(() => {
      if (this.querySelector(".klaviyo-form > *")) {
        this.jsFooterForm();
      }
    }, 100);
  }

  jsFooterForm() {
    clearInterval(this.intervalFooter);
    this;
    var knName = this.querySelector(".klaviyo-form input[id*='first_name']");
    var knEmail = this.querySelector(".klaviyo-form input[id*='email']");
    var knLegal = this.querySelector(".klaviyo-form div[aria-labelledby*='kl_Accepts']");
    var knButton = this.querySelector(".klaviyo-form button");
  
    const onNewsletterFocusk = (event) => {
      knLegal.style.setProperty("display", "block", "important");
      knButton.style.setProperty("display", "block", "important");
    }
  
    if (knName != null && knName != undefined && knEmail != null && knEmail != undefined) {
      knName.addEventListener('focus', onNewsletterFocusk);
      knEmail.addEventListener('focus', onNewsletterFocusk);
    }
  }
}

customElements.define('klaviyo-newsletter', KlaviyoNewsletter);